module.exports = __webpack_public_path__ + "img/no-data.455c0328.svg";